import React, { useCallback, useState } from 'react'
import { THorse } from '../../shared/types/horse.type'
import HorseInfoCard from './HorseInfoCard'
import { Grid } from '@mui/material'
import CommentSection from './CommentSection'
import HorseHr from './HorseHr'
import HorseAnalytics from './HorseAnalytics'
import { useExam } from '../../hooks/useExam'
import { useAuth } from '../../hooks/useAuth'
import { hydraTransform } from '../../shared/utils/hydraTransformer'
import { TtrainingKeyParameterItem } from '../../shared/types/TrainingKeyParameterItem.type'
import { toast } from 'react-toastify'
import { t } from 'i18next'
import PerformanceAnalytics from './PerformanceAnalytics'
import { isEmpty } from 'lodash'
import { Ttraining } from '../../shared/types/training.type'

type HorseViewProps = {
    horse?: THorse,
    onExamParamsChanged: (data: TtrainingKeyParameterItem[]) => void,
    examParams: TtrainingKeyParameterItem[],
    updateComment: (comment: string) => void,
    isCommentUpdating: boolean,
    horseExams: Ttraining[]

}

function HorseView({ horse, onExamParamsChanged, examParams, updateComment, isCommentUpdating, horseExams }: HorseViewProps) {
    const { auth } = useAuth()
    const { compare } = useExam(false, auth?.['@id'])
    const [date, setDate] = useState<string | undefined>(undefined)

    const getQueryForIds = (ids: number[]) => {
        let str: string[] = []
        ids.forEach(id => {
            str.push(`${encodeURIComponent('training[]')}=${encodeURIComponent(id)}`)
        })

        return str.join('&')
    }

    const onTrainingIdsChange = useCallback(async (ids: number[]) => {

        if (isEmpty(ids)) {
            onExamParamsChanged([])
            return
        }

        try {
            let response = await compare.mutateAsync({ ids: getQueryForIds(ids), allKeyParam: false, options: `${encodeURIComponent(' additional-groups[]')}=training:maxHeartRate` })
            onExamParamsChanged(response.data.items)
        } catch (error) {
            toast(t('error:generic'), { type: 'error' })
        }
    }, [])

    const handlePeriodChange = (date?: string) => {
        setDate(date)
    }

    return (
        <>
            <Grid container spacing={2}>
                <Grid item md={7} xs={12}>
                    <HorseInfoCard horse={horse}></HorseInfoCard>
                </Grid>
                <Grid item md={5} xs={12}>
                    <CommentSection
                        defaultComment={horse?.active_horse_comment?.comment}
                        updateComment={updateComment}
                        isCommentUpdating={isCommentUpdating}
                    />
                </Grid>
                <Grid item md={12} xs={12}>
                    <HorseHr
                        isComparing={compare.isLoading}
                        horse={horse}
                        examParams={examParams}
                        horseExams={horseExams}
                    />
                </Grid>
                <Grid item md={12} xs={12}>
                    <HorseAnalytics
                        date={date}
                        onTrainingIdsChange={ids => onTrainingIdsChange(ids)}
                        horse={horse} />
                </Grid>
                <Grid item md={12} xs={12}>
                    <PerformanceAnalytics
                        isLoading={compare.isLoading}
                        examParams={examParams}
                        handlePeriodChange={handlePeriodChange}
                    />
                </Grid>
            </Grid>
        </>
    )
}

export default HorseView